function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70px",
    height: "70px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.761
    },
    fill: "#4aa670",
    d: "M 25.5,-0.5 C 31.5,-0.5 37.5,-0.5 43.5,-0.5C 56.8333,3.5 65.5,12.1667 69.5,25.5C 69.5,31.5 69.5,37.5 69.5,43.5C 65.5,56.8333 56.8333,65.5 43.5,69.5C 37.5,69.5 31.5,69.5 25.5,69.5C 12.1667,65.5 3.5,56.8333 -0.5,43.5C -0.5,37.5 -0.5,31.5 -0.5,25.5C 3.5,12.1667 12.1667,3.5 25.5,-0.5 Z M 29.5,4.5 C 55.151,5.16172 66.3177,18.1617 63,43.5C 59.1365,54.8533 51.3032,61.6866 39.5,64C 21.3252,65.1501 9.82525,56.9835 5,39.5C 4.05252,21.3037 12.2192,9.637 29.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.013
    },
    fill: "#4ba770",
    d: "M 45.5,42.5 C 46.2891,42.7828 46.9558,43.2828 47.5,44C 46.184,44.5281 45.5173,44.0281 45.5,42.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/starEmpty.528bcd2bc0af825fd9ecebf90f10eadf.svg";
export { ForwardRef as ReactComponent };